<template>
<div>
  <div class="asset-form _flxccc">
    <asset></asset>
  </div>
</div>
</template>

<script>
import Asset from '../asset'

export default {
  name: 'edit',
  props: ['item'],
  components: { Asset }
}
</script>
